import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LazyLoading from "react-lazy-load";
import Slider from "react-slick";

import {
  ChevronLeftIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchHistoryMessages,
  fetchMessages,
  messagesSelector,
} from "../../service/redux/messages/messagesSlice";
import { usersSelector } from "../../service/redux/users/usersSlice";
import LazyLoad from "react-lazy-load";
import io from "socket.io-client";
import { handleErrorImg } from "../../service/utils/utils";

import { Auth } from "../../service/utils/auth";
import MessageHistoryItem from "./MessageHistoryItem";
import UserOtherItem from "./UserOtherItem";
import AuthGuard from "../shared/AuthGuard";

// import NavMobile from "../NavMobile/NavMobile"; // Component không tồn tại
import config from "../../configs/Configs.json";
const { URL_BASE64, API__SERVER } = config;

const socket = io("https://iudi-api.thinkdiff.us");

const Message = () => {
  var settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  const { id } = useParams();
  const { userID, userName } = new Auth();

  const [userIdOtherList, setUserIdOtherList] = useState([]);
  const [userOtherList, setUserOtherList] = useState([]);

  const { historyMessages, postToggle, isSeenMessage } =
    useSelector(messagesSelector) || {};

  const dispatch = useDispatch();
  const userState = useSelector(usersSelector);

  // Debug logs
  console.log("🔍 DEBUG Message Component:");
  console.log("📊 UserID:", userID);
  console.log("📨 History Messages:", historyMessages);
  console.log("🔄 Post Toggle:", postToggle);

  useEffect(() => {
    // client connect to server
    // socket.emit("userId", { userId: userID });

    // socket.on("check_message", (message) => {
    //   const { ReceiverID, IsSeen } = message.data;
    //   dispatch(fetchHistoryMessages(ReceiverID ?? IsSeen?.ReceiverID));
    // });

    socket.on("online", (data) => {
      // console.log(data.user);
      setUserIdOtherList(data.user);
    });
  }, [userID]);

  useEffect(() => {
    console.log("🚀 Fetching history messages for userID:", userID);
    if (userID) {
      dispatch(fetchHistoryMessages(userID))
        .unwrap()
        .then((result) => {
          console.log("✅ API Response SUCCESS:", result);
          console.log("📊 Data:", result.data);
          console.log("📈 Unread count:", result.message_no_send);
        })
        .catch((error) => {
          console.error("❌ API ERROR:", error);
          console.error("🔴 Backend có lỗi, không thể load tin nhắn");
          alert(
            "⚠️ Không thể tải tin nhắn. Backend API đang gặp sự cố:\n" +
              "Table 'Users' không tồn tại trong database.\n\n" +
              "Vui lòng liên hệ team Backend để fix database."
          );
        });
    }
  }, [postToggle, userID]);

  const getProfileChat = async (id) => {
    if (id && id !== parseInt(userID)) {
      const { data } = await axios.get(
        `https://iudi-api.thinkdiff.us/api/chat/${id}`
      );
      const user = {
        id: data.data[0]?.UserID,
        username: data.data[0]?.Username,
        avatar: data.data[0]?.Avatar,
      };

      const isMatch = userOtherList.some(
        (user) => user.id === data.data[0].UserID
      );

      if (data.data.length > 0 && isMatch === false) {
        setUserOtherList([...userOtherList, user]);
      }
    }
  };

  useEffect(() => {
    userIdOtherList.forEach((id) => {
      getProfileChat(id);
    });
  }, [userIdOtherList]);

  //  const [relationshipList, setRelationshipList] = useState([])

  //  useEffect(() => {
  //   const getRelationshipUsers = async (userID) => {
  //    const res = await axios.get(`${API__SERVER}/chatblock/${userID}`)
  //    setRelationshipList(
  //     res.data.data.filter((user) => user.RelationshipType === 'block')
  //    )
  //   }

  //   getRelationshipUsers(userID)
  //  }, [userID])

  //  useEffect(() => {
  //   if (relationshipList.length > 0 && historyMessages.length > 0) {
  //    const newHistory = []

  //    historyMessages.filter((message, index) => {
  //     return message.OtherUserID !== 380
  //    })

  //    console.log(historyMessages)
  //   }
  //  }, [relationshipList, historyMessages])

  return (
    <AuthGuard
      feature="Tin nhắn"
      message="Bạn cần đăng nhập để xem và gửi tin nhắn"
      showLockIcon={true}
      blurContent={true}
    >
      <div className="hidden mb-4 mobile:block ">
        <div className="flex items-center justify-between p-4 border-b-[#817C7C] border-b border-solid">
          <Link to="/">
            <button className="w-6 h-6 ">
              <ChevronLeftIcon />
            </button>
          </Link>
          <span className="text-2xl font-bold">Chat</span>
          <button className="w-6 h-6">
            <MagnifyingGlassIcon />
          </button>
        </div>
      </div>
      <Slider {...settings}>
        <div className="text-center">
          <Link to={`/profile/${userName}`}>
            <LazyLoading>
              <img
                className="mx-auto w-[73px] h-[73px] tablet:w-[60px] tablet:h-[60px] mobile:w-[50px] mobile:h-[50px] rounded-full object-cover"
                src={`${userState.user.avatarLink}`}
                alt="avatar"
                onError={(e) => handleErrorImg(e.target)}
              />
            </LazyLoading>
            <h5 className="font-medium capitalize">{userName}</h5>
          </Link>
        </div>

        {userOtherList.length > 0
          ? userOtherList.map(({ id, username, avatar }) => {
              const imgAvatarRef = React.createRef();

              return (
                <UserOtherItem
                  key={id}
                  data={{
                    id,
                    username,
                    avatar,
                    ref: imgAvatarRef,
                  }}
                />
              );
            })
          : ""}
      </Slider>

      <div className="mobile:px-3">
        <ul>
          {historyMessages && historyMessages.length > 0 ? (
            historyMessages.map(
              ({
                MessageID,
                Content,
                OtherUsername,
                Avatar,
                OtherAvatar,
                MessageTime,
                OtherUserID,
                IsSeen,
                SenderID,
                imageLink: Image,
              }) => {
                let isOnline = false;
                userIdOtherList.some(
                  (userId) => (isOnline = userId === OtherUserID)
                );

                const imgAvatarRef = React.createRef();

                return (
                  <MessageHistoryItem
                    key={MessageID}
                    data={{
                      MessageID,
                      Content,
                      OtherUsername,
                      OtherAvatar,
                      Avatar,
                      MessageTime,
                      OtherUserID,
                      refImg: imgAvatarRef,
                      isOnline,
                      idParams: id,
                      SenderID,
                      IsSeen,
                      isSeenMessage,
                      Image,
                    }}
                  />
                );
              }
            )
          ) : (
            <li className="text-center py-8 text-gray-500">
              {historyMessages === undefined ? (
                <div>
                  <p>⏳ Đang tải tin nhắn...</p>
                </div>
              ) : (
                <div>
                  <p>📭 Chưa có tin nhắn nào</p>
                  <p className="text-sm mt-2">
                    Bắt đầu trò chuyện với bạn bè của bạn!
                  </p>
                </div>
              )}
            </li>
          )}
        </ul>
      </div>

      {/* Mobile menu */}
      {/* <NavMobile /> */}
    </AuthGuard>
  );
};

export default Message;
